<template>
  <v-app>
    <Header></Header>
    <v-main class="deep-purple lighten-5">
      <router-view></router-view>
      <Loader></Loader>
      <Alert></Alert>
      <Confirm></Confirm>
    </v-main>
  </v-app>
</template>

<script>
import Loader from "./components/loader/Loader.vue";
import Confirm from "./components/confirm/Confirm.vue";
import Alert from "./components/alert/Alert.vue";
import Header from "./components/Header.vue";
import { PROVIDERS } from "./assets/js/common";

export default {
  name: "App",
  components: {
    Header,
    Confirm,
    Loader,
    Alert,
  },
  methods: {
    init() {
      const vm = this;
      vm.$store.commit("SET_USER");
      vm.$store.dispatch("getDashboard");
      vm.$store.dispatch("getSubjects");
      vm.$store.dispatch("fetchStates");

      Object.keys(PROVIDERS).forEach((key) => {
        let params = PROVIDERS[key];
        vm.$store.dispatch("getProviders", { params, key });
      });
    },
  },
  beforeMount() {
    this.init();
  },
};
</script>
<style lang="scss">
@import url(./assets/scss/common.scss);
.custom__table {
  white-space: nowrap;
  th {
    background: #eeeeee !important;
    color: rgba(0, 0, 0, 0.7) !important;
    span {
      text-transform: uppercase !important;
    }
  }
  th {
    i {
      display: none !important;
    }
  }
}
</style>
